// extracted by mini-css-extract-plugin
module.exports = {"root":"QPbVk6f4"};